import script from "./Show_registration.vue?vue&type=script&setup=true&lang=js"
export * from "./Show_registration.vue?vue&type=script&setup=true&lang=js"

import "./Show_registration.vue?vue&type=style&index=0&id=3379817a&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Nakhoncity\\Nakhoncity-App-Queue-Idcard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3379817a"]])

export default __exports__